// src/hooks/audience/useMediaSearch.js
import { useCallback, useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_AUDIENCE_CLASSIFICATION_MEDIA_SEARCH } from "../../routes";

export function useMediaSearch() {
  const [mediaResults, setMediaResults] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [mediaError, setMediaError] = useState("");

  // No sourceId/titleLabel means "list everything" (up to take) - used both for
  // the initial page load and when the user clears the search fields, so the
  // table never has to sit empty until a search is typed.
  const searchMedia = useCallback(async (sourceId, titleLabel) => {
    setMediaLoading(true);
    setMediaError("");
    try {
      const resp = await Api.post(
        API_ROUTE_AUDIENCE_CLASSIFICATION_MEDIA_SEARCH,
        {
          sourceId: sourceId?.trim() || null,
          titleLabel: titleLabel?.trim() || null,
          take: 100,
        },
      );
      setMediaResults(Array.isArray(resp.data) ? resp.data : []);
    } catch (err) {
      setMediaResults([]);
      setMediaError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to search media.",
      );
    } finally {
      setMediaLoading(false);
    }
  }, []);

  return {
    mediaResults,
    mediaLoading,
    mediaError,
    setMediaError,
    searchMedia,
  };
}
